<template>
  <layout-base>
    <slot />
  </layout-base>
</template>
